module.exports = __webpack_public_path__ + "img/bb_g3_antenna-02.ca1936b7.svg";